import { render } from "./ContextPage.vue?vue&type=template&id=8110f2c6&scoped=true"
import script from "./ContextPage.vue?vue&type=script&lang=js"
export * from "./ContextPage.vue?vue&type=script&lang=js"

import "./ContextPage.vue?vue&type=style&index=0&id=8110f2c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8110f2c6"]])

export default __exports__